import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassYeargroupReadSlice = createSlice({
  name: "ClassYeargroupReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassYeargroupRead: (state) => {
      state.isLoading = true;
    },
    successClassYeargroupRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassYeargroupRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassYeargroupRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassYeargroupRead,
  successClassYeargroupRead,
  failureClassYeargroupRead,
  clearClassYeargroupRead,
} = ClassYeargroupReadSlice.actions;

export default ClassYeargroupReadSlice.reducer;
